import { render, staticRenderFns } from "./trashCollectAmountCard.vue?vue&type=template&id=934556ca&scoped=true&"
import script from "./trashCollectAmountCard.vue?vue&type=script&lang=js&"
export * from "./trashCollectAmountCard.vue?vue&type=script&lang=js&"
import style0 from "./trashCollectAmountCard.vue?vue&type=style&index=0&id=934556ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934556ca",
  null
  
)

export default component.exports